import ProductListingPage from "./ProductListingPage";

export default require("../../containers/withTogglePoint").default(ProductListingPage, require.context("./__variants__/", true, /^\.\/([^/]+\/){2}index\.js$/))
